export default __webpack_public_path__ + "static/media/remove-blue.e97a58ae.svg";